import {useTranslation} from "react-i18next";

import {useNavigateWithQuery} from "../../hooks/navigationHooks";
import type {PersistenceAddressData} from "../../redux/addressSlice";
import {handlePreventDefault} from "../../util/events";

interface AddressElementProps {
    addressData: PersistenceAddressData | null;
    matchPathAddress: boolean;
}

/**
 * Header Element - address information.
 */
export default function AddressElement({addressData, matchPathAddress}: AddressElementProps) {
    const {t} = useTranslation();
    const navigate = useNavigateWithQuery();

    if (matchPathAddress || !addressData) return null;

    const addressRoute = "/address";

    const orderAddress = addressData.orderAddressClean;
    const referenceAddress = addressData.addressClean;

    const displayedAddress = addressData.hasReferenceAddress
        ? t("header.addressWithReferenceAddress", {orderAddress, referenceAddress})
        : orderAddress;

    return (
        <div className="SecondaryHeaderElement mt-4">
            <span id="header-address-element" className="pi pi-map-marker mr-2"></span>
            <a href={addressRoute} onClick={handlePreventDefault(() => navigate(addressRoute))}>
                {displayedAddress}
            </a>
        </div>
    );
}
